<div class="row">
  <div class="col-10">
    <nav class="navbar navbar-expand-lg ">
      <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
    </nav>
  </div>
  <div class="col-2 mainlogout">
    <a class="logout" routerLink="/logout" routerLinkActive="active">Logout</a>
  </div>
</div>

<br>
<br>

<div class="row justify-content-center">
  <div class="col-md-8">
    <div class="card">
      <div class="card-header">Policies</div>
      <div class="card-body">
        <form class="form-horizontal">
          <div class="form-group">
            <!-- <label for="username" class="cols-sm-2 control-label">Terms and Conditions</label> -->
            <div class="cols-sm-10">
              <div class="input-group">
                <span class="input-group-addon"></span>
                <textarea readonly class="form-control textarea" name="terms" id="terms" placeholder="There will be Terms and Conditions.There will be Terms and Conditions.I know this post has been (very well) answered by Aquarelle but just in case somebody is having this issue with other tag forms with no text such as inputs i'll leave this here:

                        If you have an input in your form and placeholder is not showing because a white space at the beginning, this may be caused for you value attribute. In case you are using variables to fill the value of an input check that there are no white spaces between the commas and the variables.

                        example using twig for php framework symfony :"></textarea>
              </div>
            </div>
            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="gridCheck" name="TOSAttestation"
                       ngModel required />
                <label class="form-check-label required" for="gridCheck">
                  Terms and Conditions
                </label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <!-- <label for="username" class="cols-sm-2 control-label">Code of Conduct</label> -->
            <div class="cols-sm-10">
              <div class="input-group">
                <span class="input-group-addon"></span>
                <textarea readonly class="form-control textarea" name="code-of-conduct"
                          id="code-of-conduct" placeholder="There will be code-of-conduct.There will be code-of-conduct.I know this post has been (very well) answered by Aquarelle but just in case somebody is having this issue with other tag forms with no text such as inputs i'll leave this here:

                        If you have an input in your form and placeholder is not showing because a white space at the beginning, this may be caused for you value attribute. In case you are using variables to fill the value of an input check that there are no white spaces between the commas and the variables.

                        example using twig for php framework symfony :"></textarea>
              </div>
            </div>
            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="gridCheck"
                       name="CodeOfConductAttestation" ngModel required />
                <label class="form-check-label required" for="gridCheck">
                  Code of Conduct
                </label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-lg btn-block login-button">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
